var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"SelectTags"},[_c('v-select',{attrs:{"items":_vm.banksTags,"item-text":"name","item-value":"id","multiple":"","label":_vm.readOnly ? 'Тег (только чтение)' : 'Тег',"readonly":_vm.readOnly},model:{value:(_vm.values),callback:function ($$v) {_vm.values=$$v},expression:"values"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }